
import { TimeIntervalEnum } from "../enums/timeIntervalEnum";

import * as main            from "../main";
import * as moment          from "moment";
import * as timeinterval    from "../timeinterval";
import * as grid            from "../grid"; 

let LABEL_ETooManyDays = "";
let dateTimeErrorMessageLabel = "";

export function initialize(ETooManyDays: string, dateTimeErrorMessage: string): void {
    LABEL_ETooManyDays = ETooManyDays;
    dateTimeErrorMessageLabel = dateTimeErrorMessage;

    main.setHideDiv("errorMessage", false);
    main.setHideDivBootstrap("periodSelector", false);
    main.setHideDiv("DivGridMsg", false);
    grid.loadGridOptions("PagerLogGrid");
    searchButtonClicked();
}

export function searchButtonClicked(): void {
    $("#SearchButtonLoader").show();

    main.setHideDiv("DivLblTooMany", false);
    main.setHideDiv("DivGridMsg", false);
    main.setHideDiv("errorMessage", false);

    const selectedInterval = parseInt($("#TimeIntervalID").data("kendoDropDownList").value());
    const from = timeinterval.getBeginPeriodSelection(selectedInterval, null);
    const to = timeinterval.getEndPeriodSelection(selectedInterval, null);

    if (from != null && to != null) {
        const grid = $("#PagerLogGrid").data("kendoGrid");
        if (grid != null && grid != undefined) {
            grid.pager.dataSource.page(1);
            grid.dataSource.read();
        }
    }
    else {
        $("#SearchButtonLoader").hide();
        // make a message
        main.setHideDiv("errorMessage", true);

        const lblError = $("#errorMessageLabel");
        if (lblError != null && lblError != undefined) {
            lblError.text(dateTimeErrorMessageLabel);
        }
    }
}

export function getAdditionalData(): {
    nodes: number,
    SnId: string | null,
    msgType: number,
    timestampFrom: Date,
    timestampTo: Date
} {

    // defaults
    const beginDateTime = moment();
    let toLocal = new Date(beginDateTime.unix() * 1000);
    let fromLocal = new Date(beginDateTime.subtract(1, 'days').unix() * 1000);
    let nodes = 0;
    let SnId = null;
    let cbbTypeVal = 0;

    // node
    const cbbNodes = $("#CBB_Nodes").data("kendoDropDownList");
    if (cbbNodes != null && cbbNodes != undefined) {
        nodes = parseInt(cbbNodes.value());
    }

    // user
    const cbbUsers = $("#CBB_User").data("kendoDropDownList");
    if (cbbUsers != null && cbbUsers != undefined) {
        SnId = cbbUsers.value();
    }

    // type
    const cbbType = $("#CBB_Type").data("kendoDropDownList");
    if (cbbType != null && cbbType != undefined) {
        const typevalue = cbbType.value();
        if (typevalue != '') {
            cbbTypeVal = parseInt(typevalue);
        }
    }

    // timeinterval
    const ddl = $("#TimeIntervalID").data("kendoDropDownList");
    if (ddl != null && ddl != undefined) {
        const ddlval = parseInt(ddl.value());
        fromLocal = timeinterval.getBeginPeriodSelection(ddlval, null);
        toLocal = timeinterval.getEndPeriodSelection(ddlval, null);

        const tsDays = (toLocal.getTime() - fromLocal.getTime()) / (1000 * 3600 * 24);
        if (tsDays < 0 || tsDays >= 33) {

            // make a message
            main.setHideDiv("DivLblTooMany", true);

            var lblEmsg = $("#LblTooMany");
            if (lblEmsg != null && lblEmsg != undefined) {
                lblEmsg.text(LABEL_ETooManyDays);
            }

            fromLocal = toLocal = new Date(Date.now());
        }
    }

    return {
        nodes: nodes,
        SnId: SnId,
        msgType: cbbTypeVal,
        timestampFrom: fromLocal,
        timestampTo: toLocal
    };
}
